import type { LearningItemView } from '../api/content.types';

const JA_LANGUAGE = 'ja-JP';
/// Chậm hơn mặc định một chút — người mới học cần nghe rõ từng mora.
const JA_RATE = 0.85;

/**
 * Đọc 1 chuỗi tiếng Nhật bằng Web Speech API (tương đương expo-speech ở mobile).
 * `cancel()` trước để bấm liên tiếp không bị chồng tiếng.
 */
export function speakJa(text: string): void {
  if (typeof window === 'undefined' || !('speechSynthesis' in window)) return;
  window.speechSynthesis.cancel();
  const utterance = new SpeechSynthesisUtterance(text);
  utterance.lang = JA_LANGUAGE;
  utterance.rate = JA_RATE;
  window.speechSynthesis.speak(utterance);
}

/**
 * Chuỗi để đọc của 1 learning item — ưu tiên `ttsText` do API cung cấp, fallback về
 * kana/character chứ KHÔNG dùng kanji (TTS hay đọc sai âm on/kun khi đứng lẻ).
 */
export function ttsTextOf(item: LearningItemView): string | null {
  if (item.itemType === 'VOCAB') return item.ttsText ?? item.kana;
  if (item.itemType === 'GRAMMAR') return item.title;
  return item.ttsText ?? item.character;
}
